import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function DiscardNewTemplateDialog({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { search } = useLocation();
  const { templateType } = useParams();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <Header
          title="Discard new template?"
          subtitle="Are you sure you want to discard this template?"
        />

        <Footer className="items-center justify-end">
          <Close asChild>
            <Button variant="secondary-black">Cancel</Button>
          </Close>

          <Button
            data-cy="delete-template-button"
            variant="outline-danger"
            onClick={() => {
              navigate({ pathname: "..", search });
              sessionStorage.removeItem(templateType.toUpperCase());
            }}
          >
            Discard
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
